import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {TextField, Link, ThemeContext} from '../../../common';
import {MAX_NAME_LEN} from '../../../../configs/constants';
import {nolongerErrorMessage} from '../../../../configs/messages';

const validateName = (name = '', allValues, label) => {
  if (name.length > MAX_NAME_LEN) {
    return nolongerErrorMessage(label, MAX_NAME_LEN);
  }

  return null;
};

const UserAccount = ({points, editMode}) => (
  <ThemeContext.Consumer>
    {theme => (
      <Fragment>
        <h3 className="user-profile__points" style={{color: theme.secondaryColor}}>
          Points earned:&nbsp;
          <span>{points}</span>
        </h3>
        <TextField
          label="First Name"
          labelClass="col-3 text-right"
          inputClass="col-9"
          name="firstName"
          maxLength={81}
          validatorsArray={[validateName]}
          required
          isRow
          readOnly={!editMode}
        />
        <TextField
          label="Last Name"
          labelClass="col-3 text-right"
          inputClass="col-9"
          name="lastName"
          maxLength={81}
          validatorsArray={[validateName]}
          required
          isRow
          readOnly={!editMode}
        />
        {editMode && (
          <div className="row form__row form__row_gap_s">
            <div className="col-9 offset-3 user-profile__password">
              <Link to="/profile/password" text="Edit Password"/>
            </div>
          </div>
        )}
      </Fragment>
    )}
  </ThemeContext.Consumer>
);

UserAccount.propTypes = {
  points: PropTypes.number.isRequired,
  editMode: PropTypes.bool,
};

UserAccount.defaultProps = {
  editMode: false,
};

export default UserAccount;
